import React from 'react';
import './Translation.css';

const Translation = (props) => { 
    return (
        <div className="translation container">
            <h3>Join the Career track</h3>
            <div className='translation_video'>
                <iframe className='translation_video_frame' width="900" height="500" src="https://www.youtube.com/embed/eFqazPFwx4k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
        </div>
    );
};

export default Translation;